import { Component, OnInit } from '@angular/core';
import { AccountsLoginModel } from '../../models/login-user-model';
import { AccountsLoginService } from '../../services/accounts-login-service';
import { UtilityService } from '../../services/utility-service';
import { SystemUserParameters } from '../../models/system-user-param-model';
import { environment } from 'src/environments/environment';
import { error } from 'jquery';
import { filterMenuByRole } from 'src/app/modules/notification-system/services/menu-util-service';
import { APP_MENUS } from 'src/app/modules/notification-system/models/menu-config-utility';

@Component({
  selector: 'app-accounts-login',
  templateUrl: './accounts-login.component.html',
  styleUrls: ['./accounts-login.component.css'],
})
export class AccountsLoginComponent implements OnInit {
  public l_formdata: AccountsLoginModel = new AccountsLoginModel();
  public sessionStorage: Storage = sessionStorage;
  envHeading = '';
  isTestEnvironment: boolean = false;

  constructor(
    private l_accountsLoginService: AccountsLoginService,
    private l_UtilityService: UtilityService
  ) {}

  ngOnInit(): void {
    const rootUrl = environment.ROOT_URL;
    // this.envHeading = rootUrl.includes('jsyogservicestest')
    //   ? 'JSYOG Accounts Test Environment'
    //   : 'JSYOG Accounts';
    this.envHeading = 'SmartPing';
    this.isTestEnvironment = rootUrl.toLowerCase().includes('test');
  }

  public l_hideView = true;

  lFN_TogglePasswordVisibility() {
    this.l_hideView = !this.l_hideView;
  }

  lFN_LoginUser() {
    if (!this.l_formdata.username || !this.l_formdata.password) {
      this.l_UtilityService.lFN_WarningToaster(
        'Unable to process request',
        'Username and password required'
      );
      return;
    }

    this.l_UtilityService.lFN_ShowLoader();

    this.l_accountsLoginService
      .lFN_login(this.l_formdata.username, this.l_formdata.password)
      .subscribe({
        next: (response) => {
          sessionStorage.setItem('auth_token', response.token);
          sessionStorage.setItem('user_id', response.userId.toString());
          sessionStorage.setItem('username', response.username);
          sessionStorage.setItem('full_name', response.fullName);
          sessionStorage.setItem('role', response.role);

          // ✅ Store full client data
          sessionStorage.setItem(
            'client_master',
            JSON.stringify(response.clientMaster)
          );

          this.l_UtilityService.lFN_SuccessToaster(
            'Login successful',
            'Success'
          );
          // const data = JSON.parse(sessionStorage.getItem('client_master'));
          // console.log(data.clientName);
          // console.log(data.clientId);

          // Continue with your existing flow
          this.lFN_ProcessLogin(response.role);
        },
        error: (err) => {
          this.l_UtilityService.lFN_ErrorToaster(
            'Login failed',
            err?.error?.message || 'Invalid credentials'
          );
          this.l_accountsLoginService.lFN_ConveyLoginStatus(false);
          this.l_UtilityService.lFN_HideLoader();
        },
        complete: () => {
          this.l_UtilityService.lFN_HideLoader();
        },
      });
  }

  lFN_ProcessLogin(role: string) {
    const filteredMenu = filterMenuByRole(APP_MENUS, role);

    sessionStorage.setItem('menu_nav_items', JSON.stringify(filteredMenu));

    // 🔥 notify sidebar
    this.l_accountsLoginService.lFN_ConveyLoginStatus(true);

    this.l_UtilityService.lFN_Navigate('userdashboard', 'userdashboard');
  }

  async lFN_SetAccessControl(l_systemParameters: SystemUserParameters) {
    console.log(
      'lFN_SetAccessControl l_systemParameters === ',
      l_systemParameters
    );

    const menuBarItemsAdmins = [
      {
        name: 'System Configuration',
        path: 'systemconfig',
        icons: 'domain',
        children: [
          {
            name: 'Users',
            path: 'users',
            icons: 'people',
            children: [],
          },
          {
            name: 'Services',
            path: 'services',
            icons: 'miscellaneous_services',
            children: [],
          },
          {
            name: 'SMS Templates',
            path: 'sms-templates',
            icons: 'sms',
            children: [],
          },
          {
            name: 'Category',
            path: 'category',
            icons: 'category',
            children: [],
          },
          {
            name: 'Service Template Mapping',
            path: 'service-template-mapping',
            icons: 'link',
            children: [],
          },
        ],
      },
      {
        name: 'Reports',
        path: 'reports',
        icons: 'image_search',
        children: [
          {
            name: 'Donations Report',
            path: 'donationreport',
            icons: 'attach_money',
            children: [],
          },
        ],
      },
    ];

    return menuBarItemsAdmins;
  }
  lFN_logoutUnauthorizedUser() {
    this.l_UtilityService.lFN_ShowLoader();
    let l_response = this.l_accountsLoginService.lFN_logout();
    l_response.subscribe({
      next: async (data) => {
        if (data.status == 200) {
          setTimeout(() => {
            this.sessionStorage.clear();
            this.l_UtilityService.lFN_Navigate('unauthorized', 'create');
          }, 500);
          this.l_UtilityService.lFN_HideLoader();
        }
      },
      error: (l_error) => {
        console.error('error_response: ', l_error);
        this.l_UtilityService.lFN_ErrorToaster('Unable to logout.', 'Failure');
        this.l_UtilityService.lFN_HideLoader();
      },
      complete: () => {
        console.log('Request completed');
        this.l_UtilityService.lFN_HideLoader();
      },
    });
  }
}
